import React from "react";

const DevTools = React.lazy(() =>
	// eslint-disable-next-line import/no-extraneous-dependencies
	import("@tanstack/react-query-devtools").then(d => ({
		default: d.ReactQueryDevtools,
	})),
);

export default function ReactQueryDevTools() {
	/**
	 * If the app is running in production, we
	 * don't want to load the dev tools.
	 */
	if (process.env.NODE_ENV !== 'development') return null;

	return (
		<React.Suspense fallback={null}>
			<DevTools  initialIsOpen/>
		</React.Suspense>
	);
}
